<app-header></app-header>
<app-announcement></app-announcement>
<div class="container-fluid blw_headermain">

  <!-- tab starts here -->
  <div class="row">
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 transaction_main" id="exTab1">
      <ul class="nav nav-pills nav_main">
        <li [class.active]="activeTab === 'transactions'">
          <a (click)="activeTab = 'transactions'">Transactions</a>
        </li>
        <li [class.active]="activeTab === 'refund'" [ngClass]="hiderefund ? 'refund-hide' : 'refund-unhide'">
          <a (click)="activeTab = 'refund'">Refund</a>
        </li>
      </ul>

      <!-- Transacrion Tabs starts here -->
      <div class="tab-content clearfix">
        <div class="tab-pane" [ngClass]="{'active': activeTab === 'transactions' }" id="1a">

          <!-- Arvind button alinment -->

          <div class="userbtn_main" style="width:967px">

            <div class="row align-items-center g-2 filters-container">

              <div class="col-lg-2 col-md-3 col-sm-4 col-xs-6">
                <p-datepicker [(ngModel)]="value1" [showIcon]="true" iconPos="left" placeholder="From Date"
                  appendTo="body"></p-datepicker>
              </div>

              <div class="col-lg-2 col-md-3 col-sm-4 col-xs-6">
                <p-datepicker [(ngModel)]="value2" (click)="ValidateToDate()" [showIcon]="true"
                  placeholder="To Date"></p-datepicker>
              </div>

              <div class="col-auto d-flex gap-2">
                <button type="button" (click)="OnClickdate();" class="btn btn-primary d-flex align-items-center gap-1 datesearch" style="min-width: 180px;">
                  <i class="fa fa-calendar"></i>
                  <span>Date Search</span>
                </button>
                <button type="button" (click)="DownloadTransactionReport();" class="btn download_report d-flex align-items-center justify-content-center" style="min-width: 180px;">
                  <span class="glyphicon glyphicon-download"></span>
                  <span class="mx-2">Download Report</span>
                </button>
                
              </div>
              <!-- button alinment -->


              <div style="width: 65.5% !important">
                <span class="input-ErrorField"
                  [ngClass]="(Validateenddate ==true)?'container-hide':'container-unhide'">Transaction End date cannot
                  be greater than Transaction Start date</span>
              </div>

            </div>

          </div>

          <div class="transaction_refund">
            <div class="searchmain" style="margin-bottom: 5px !important">
              <div class="checkbox checkbox_main col-lg-4 col-md-3 col-sm-2 col-xs-2">
                <label>
                  <input class="checkbox_modified" type="checkbox" [disabled]="isSelectedMultipleInovice"
                    [(ngModel)]='isshowtransChecked' value="CheckTransactions" (change)="onShowTransChecked($event)" />
                  <span class="Show_transaction"> Show all batched payments</span>
                </label>
              </div>

              <input id="TransactionGlobalSearch" #TransactionGlobalSearch type="text" class="searchbox" pInputText
                size="50" style="width: 35% !important" placeholder="Search Alphanumeric values here..."
                [(ngModel)]="transactionGlobalFilter" (input)="dtTrans.filterGlobal($event.target.value, 'contains')" />
              <i class="fa fa-search search_modified"></i>
            </div>


            <div>
              <p-table #dtTrans
                   [value]="transaction"
                   [globalFilterFields]="TransactionFilterFields"
                  
                   class="transaction_table"
                   [rows]="10"
                   [paginator]="true"
                   [responsive]="true"
                   [pageLinks]="10"
                   [loading]="loadingTransaction"
                   [emptyMessage]="'No Record Found!'"
                   [style]="{'font-size':'12px','width':'100%','border-collapse': 'collapse','border': '1px solid #c5c5c5'}"
                   [tableStyle]="{'table-layout':'fixed','width':'100%','border-collapse': 'collapse','border': '1px solid #c5c5c5','min-width':'400px'}"
                   [showEmptyMessage]="true"
                   >


                <ng-template pTemplate="header">
                  <tr>
                    <th class="table-style" style="width: 40px;">
                    </th>


                    <th class="table-style" style="font-weight: 900;">Type</th>
                    <th style="font-weight: 900; width:85px;">
                      Transaction<br />Type
                    </th>
                    <!-- changes after 2pm today -->
                    <th style="font-weight: 900;  width:85px;">
                      Transaction<br />Date
                    </th>
                    <th style="font-weight: 900; width:105px;">
                      Flight <br />
                      Start Date/
                      <br /> Invoice Date
                    </th>

                    <th style="font-weight: 900;width:65px">Order <br /> ID</th>
                    <th style="font-weight: 900;width:65px">Invoice <br /> ID</th>
                    <th style="font-weight: 900; width:85px;">Transaction ID</th>
                    <th style="font-weight: 900;;width:75px">Agency</th>
                    <th style="font-weight: 900;;width:65px">Agency ID</th>
                    <th style="font-weight: 900;width:105px;">Advertiser</th>
                    <th style="font-weight: 900;width:80px;">Payment <br /> Transaction <br /> Type</th>
                    <th class="table-style" style="font-weight: 900;">Payment <br /> Card <br /> No</th>
                    <th class="table-style" style="font-weight: 900;width:135px">Invoice/ Order <br /> (Cash Disc.
                      Price) $</th>


                    <th class="table-style" style="font-weight: 900;">Payment <br /> Received $</th>
                    <th class="table-style" style="font-weight: 900;">Ledger Amount</th>
                    <th class="table-style" style="font-weight: 900;">Partial Amount %</th>
                    <th class="table-style" style="font-weight: 900;">Agency Commission %</th>
                    <th class="table-style" style="font-weight: 900;">Tax %</th>
                    <th class="table-style" style="font-weight: 900;">Refund Balance $</th>
                    <th class="table-style" style="font-weight: 900;">Original Approval Code</th>
                    <th class="table-style" style="font-weight: 900;">Payment Customer Profile</th>
                    <th class="table-style" style="font-weight: 900;">Approval Code</th>
                    <th class="table-style" style="font-weight: 900;">Payment Status</th>
                    <th class="table-style" style="font-weight: 900;">Status</th>

                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-rowData>
                  <tr>
                    <td class="table-style">
                      <input
                        type="checkbox"
                        [disabled]="rowData.isProcessed"
                        (change)="onTransactionRowSelect($event, rowData)"
                        [checked]="rowData.checkedbox"
                        *ngIf="rowData.type != '' && rowData.type != 'SUB TOTAL'"
                        style="width: 100%; position: relative;" />
                    </td>
                    <!-- Type -->
                    <td class="table-style">

                      <div *ngIf="rowData.type === 'SUB TOTAL'"
                        style="color:darkgreen; font-weight: bold; font-size: 13px;">
                        {{ rowData.type }}
                      </div>
                      <div *ngIf="rowData.type !== 'SUB TOTAL'">
                        {{ rowData.type }}
                      </div>
                    </td>

                    <!-- Transaction Type -->
                    <td class="table-style">
                      {{ rowData.transactionType }}
                    </td>

                    <!-- Payment Settlement Date -->
                    <td class="table-style">
                      {{rowData.paymentSettlementDate }}
                    </td>
                    <!-- Order/Invoice Date -->
                    <td class="table-style">
                      {{ rowData.orderInvoiceDate }}
                    </td>
                    <!-- Order ID -->
                    <td class="table-style">{{rowData.orderID}}</td>
                    <td class="table-style">{{rowData.invoiceID}}</td>
                    <td class="table-style">
                      {{rowData.paymentTransID}}
                    </td>
                    <td class="table-style">
                      {{rowData.agency}}
                    </td>

                    <td class="table-style">
                      <div *ngIf="rowData.agencyTcode != 0">{{ rowData.agencyTcode }}</div>
                    </td>

                    <td class="table-style">{{rowData.advertiser}}</td>
                    <td class="table-style">{{rowData.paymentTransType}}</td>
                    <td class="table-style">{{rowData.cardNo}}</td>
                    <!-- Invoice/Order Amount -->
                    <td class="table-style">
                      <div *ngIf="rowData.type !== '' && rowData.type !== 'SUB TOTAL'" style="text-align: right;">
                        {{ rowData.orderInvoiceAmount | currency:'USD' }}
                      </div>
                    </td>
                    <!-- Payment Received -->
                    <td class="table-style">
                      <div *ngIf="rowData.amountPaid != 0 && rowData.type === 'SUB TOTAL'" style="font-weight: bold; font-size: 12px; text-align: right;">{{ rowData.amountPaid | currency:'USD' }}</div>
                      <div *ngIf="rowData.type !== '' && rowData.type !== 'SUB TOTAL'" style="text-align: right;">
                        {{ rowData.amountPaid | currency:'USD' }}
                      </div>
                    </td>
                    <!-- Ledger Amount -->
                    <td class="table-style">
                      <div *ngIf="rowData.type != '' && rowData.type === 'SUB TOTAL'" style="font-weight: bold; font-size: 12px; text-align: right;">{{rowData.ledgerAmount | currency:'USD'}}</div>
                      <div *ngIf="rowData.ledgerAmount != '' && rowData.type != 'SUB TOTAL'" style="text-align: right;">{{rowData.ledgerAmount | currency:'USD'}}</div>
                    </td>
                    <!-- Partial Payment -->
                    <td class="table-style">
                      
                      <div *ngIf="rowData.partialPayment != 0 && rowData.type != 'SUB TOTAL'" style="text-align: right;">
                        {{ rowData.partialPayment | currency:'USD' }}
                      </div>
                    </td>
                    <!-- Agency Commission -->
                    <td class="table-style"><div *ngIf="rowData.agencyCommission != 0 && rowData.type != 'SUB TOTAL'" style="text-align: right;">{{ rowData.agencyCommission }}%</div></td>
                    <!-- Tax -->
                    <td class="table-style">
                      <div *ngIf="rowData.tax != 0 && rowData.type != 'SUB TOTAL'" style="text-align: right;">{{ rowData.tax}}%</div>
                    </td>
                    <!-- Refund Balance -->
                    <td class="table-style"> 
                       <div *ngIf="rowData.type != '' && rowData.type != 'SUB TOTAL'" style="text-align: right">{{rowData.balanceAmount | currency:'USD'}}</div>
                    </td>
                    <!-- Original Approval Code -->
                    <td class="table-style">{{rowData.originalApprovalCode}}</td>
                    <!-- Payment Customer Profile -->
                    <td class="table-style">{{rowData.paymentCustomerProfile}}</td>
                    <!-- Approval Code -->
                    <td class="table-style">{{rowData.approvalCode}}</td>


                    <!-- Payment Status -->
                    <td class="table-style">
                      {{ rowData.chaseStatus }}
                    </td>

                    <!-- changes after 2pm today -->
                    <!-- Status -->
                    <td class="table-style">
                      <ng-container [ngSwitch]="rowData.status">
                        <img *ngSwitchCase="'Payment Processing'" src="/assets/images/processing.png"
                          matTooltip="Payment Processing" />
                        <img *ngSwitchCase="'Payment Paid'" src="/assets/images/paid.png" matTooltip="Payment Paid" />
                        <span *ngSwitchDefault>{{ rowData.status }}</span>
                      </ng-container>
                    </td>

                  </tr>
                </ng-template>

                <ng-template pTemplate="emptymessage">
                  <tr>
                      <td [attr.colspan]="25" style="text-align: left;"> No records found.</td>
                  </tr>
              </ng-template>
              </p-table>
            </div>
          </div>
        </div>
        <!-- Transaction Tabs ends here -->

        <!-- Refund Tabs starts here -->
        <div class="tab-pane" [ngClass]="{'active': activeTab === 'refund'}" id="2a">
          <div class="searchmain" style="margin: 0px !important">
            <input #RefundGlobalSearch type="text" class="searchbox" pInputText size="50" style="width: 35% !important"
              placeholder="Search Alphanumeric values here..."
              [(ngModel)]="refundGlobalFilter"
              (input)="dtRefund.filterGlobal($event.target.value, 'contains')" />
            <i class="fa fa-search search_modified"></i>
          </div>

          <p-table #dtRefund [value]="refund" [rows]="10" [paginator]="true" [responsive]="true" [pageLinks]="10"
            [loading]="loadingRefund" 
            [globalFilterFields]="RefundFilterFields"
            [style]="{'font-size':'11px','width':'100%','border-collapse': 'collapse','border': '1px solid #c5c5c5'}"
            [tableStyle]="{'table-layout':'inherit','width':'100%','border-collapse': 'collapse','border': '1px solid #c5c5c5'}"
            [emptyMessage]="'No Records Found!'">
            <ng-template pTemplate="header">
              <tr>
                <th style="width:38px">
                  <i class="fa fa-fw fa-filter cursorpointer" (click)="filterToggle($event)"></i>
                  <div *ngIf="showRefundFilter" class="filter-dropdown">
                    <!-- Example filter input, adjust as needed -->
                    <input type="text" pInputText placeholder="Filter Type" (input)="dtRefund.filter($event.target.value, 'type', 'contains')" />
                  </div>
                </th>
                <th class="table-style" style="font-weight: 900;">Type</th>
                <th class="table-style" style="font-weight: 900;">Order ID</th>
                <th class="table-style" style="font-weight: 900;">Invoice ID</th>
                <th class="table-style" style="font-weight: 900;">Transaction ID</th>
                <th class="table-style" style="font-weight: 900;">Approval Code</th>
                <th class="table-style" style="font-weight: 900;">Flight Start Date</th>
                <th class="table-style" style="font-weight: 900;">Agency</th>
                <!-- <th class="table-style" style="font-weight: 900;">Advertiser</th>
                <th class="table-style" style="font-weight: 900;">Advertiser ID</th> -->
                <th class="table-style" style="font-weight: 900;">Status</th>
                <th class="table-style" style="font-weight: 900;">Payment Transaction Type</th>
                <th class="table-style" style="font-weight: 900;">Payment Card No</th>
                <th class="table-style" style="font-weight: 900;">Invoice/Order (Cash Discount Price) $</th>
                <th class="table-style" style="font-weight: 900;">Payment Received $</th>
                <th class="table-style" style="font-weight: 900;">Refund $</th>
                <th class="table-style" style="font-weight: 900;">CM Comments</th>
                <th class="table-style" style="font-weight: 900;">CM Admin Comments</th>
                <th class="table-style" style="font-weight: 900;width: 350px;"></th>
              
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-rowData>
              <tr>
                <td>  
                  <!-- Intentionally blank or used for row-level controls -->
                </td>
                <td class="table-style">{{rowData.type}}</td>
                <td class="table-style">{{rowData.orderId}}</td>
                <td class="table-style">{{rowData.invoiceID}}</td>
                <td class="table-style">{{rowData.paymentTransID}}</td>
                <td class="table-style">{{rowData.approvalCode}}</td>
                <td class="table-style">{{rowData.orderInvoiceDate}}</td>
                <td class="table-style">{{rowData.agencyName?.agencyName}}</td>
                <!-- <td class="table-style">{{rowData.advertiserName?.advertiserName}}</td>
                <td class="table-style">
                  <div *ngIf="rowData.advertiserTcode != 0">{{rowData.advertiserTcode}}</div>
                </td> -->
                <td class="table-style">{{rowData.approvalStatus}}</td>
                <td class="table-style">{{rowData.paymentTransType}}</td>
                <td class="table-style">{{rowData.cardNo}}</td>
                <td class="table-style" style="text-align: right">{{rowData.orderInvoiceAmount | currency:'USD'}}</td>
                <td class="table-style" style="text-align: right">{{rowData.amountPaid | currency:'USD'}}</td>
                <td class="table-style" style="text-align: right">{{rowData.refundAmount| currency:'USD'}}
                  <div [hidden]="rowData.approvalStatus==reviseRefundTextCont">
                  </div>
                </td>
                <td class="table-style">
                  <div class="cusTable">
                    <div class="cusCell">{{rowData.cmComments}}</div>
                    <div style="cursor:pointer" class="input-group-addon commentsadd_on cusCell"
                      *ngIf="rowData.cmComments">
                      <i matTooltip="CM Comments History" class="fa fa-commenting-o dollar_icon" data-toggle="modal"
                        (click)="GetComments(rowData.refundDetailID)"></i>
                    </div>
                  </div>
                </td>

                <td class="table-style">
                  <div>{{rowData.cmAdminComments}}</div>
                </td>

                <!-- Action - Edit -->
               
                <td style="width: 350px;" class="table-style">
                  <div>
                    <button *ngIf="rowData.approvalStatus != reviseRefundTextCont; else reviseToRefund"
                      type="button"
                      pButton
                      class="btn add_refund"
                      (click)="AddRefund(rowData)"
                      [disabled]="rowData.refundAmount != null"
                      label="Click to Refund"
                      icon="fa fa-plus"
                      iconPos="right">
                    </button>
                    <ng-template #reviseToRefund>
                      <button
                        type="button"
                        pButton
                        class="btn add_refund revisedRefund"
                        (click)="AddRefund(rowData)"
                        label="Revise Refund"
                        icon="fa fa-plus"
                        iconPos="right">
                      </button>
                    </ng-template>
                  </div>
                </td>
            </ng-template>
          </p-table>
        </div>
        <!-- Refund Tabs ends here -->
	<!-- Arvind 1234 Save Processed Transaction -->
  <div class="col-lg-3 col-md-3 col-sm-3 col-xs-3" style="Padding:2px;">
    <button type="button" [disabled]="!SavetransBtn" class="btn transaction_btn" (click)="OnClickSaveTrans()">Batched to SAP
    </button>
</div>

      </div>

    </div>
    <footer>
      <div class="pdm-foot"></div>
    </footer>
    <!-- Popup one ends here -->
    <p-dialog header="{{commentsPopupTitle}}" [(visible)]="displayAddRefundPopUp" modal="modal" [height]="'auto'"
      [responsive]="true" [width]="500" [minWidth]="362" [minY]="362" [blockScroll]="true" [draggable]="false"
      [closable]="false">
      <form #AddRefundFrm="ngForm" (ngSubmit)="onRefundSubmitCalculation(AddRefundFrm)">
        <div>
          <span class="transaction_id">Transaction ID</span> : {{currentTrancationID}}
        </div>
        <div>
          <span class="transaction_id">Amount Paid</span> : {{amountPaid | currency:'USD'}}
        </div>
        <div *ngIf="type === 'Advance' && paymentTransType === 'CC'">
          <span class="transaction_id">Advance Amount (excluding CC surcharge)</span> : {{advancePaymentAmount |
          currency:'USD'}}
        </div>
        <div *ngIf="type != 'Advance'">
          <span class="transaction_id">Order / Invoice Amount</span> : {{orderInvoiceAmount | currency:'USD'}}
        </div>
        <div class="form-group form_main">
          <label class="control-label label_modifi" for="refund">
            <i style="color: #cc0000; ">*</i> Refund Amount
          </label>
          <div class="input-group">
            <input class="form-control input_modifi" on-paste="false" id="refundAmount" name="refundAmount" type="text"
              required [(ngModel)]="refundAmount" currencyMask pKeyFilter="money" maxlength="20" currency='USD' />
            <div class="input-group-addon add_on">
              <i class="fa fa-dollar dollar_icon"></i>
            </div>
          </div>
          <div [hidden]="(invalidAdvRefundAmnt==true)">
            <span class="input-ErrorField">Please enter the amount greater than $0 and less than Amount Paid
              {{amountPaid | currency:'USD'}}</span>
          </div>
          <div [hidden]="(invalidRefundAmnt==true)">
            <span class="input-ErrorField">Please enter an amount greater than $0 and less than Order/Invoice Amount
              {{orderInvoiceAmount | currency:'USD'}}</span>
          </div>
          <div [hidden]="(invalidAdvGrossRefundAmnt==true)">
            <span class="input-ErrorField">Please enter an amount greater than $0 and less than Advance Amount
              {{advancePaymentAmount | currency:'USD'}}</span>
          </div>
        </div>
        <div class="form-group form_main">
          <label class="control-label label_modifi labelComment" for="comments">
            <i style="color: #cc0000; ">*</i> Comments
          </label>
          <div class="input-group">
            <textarea class="form-control input_modifi" required [(ngModel)]="refundComments" id="refundComments"
              name="refundComments" type="text" maxlength="1000"></textarea>
            <div class="input-group-addon add_on">
              <i class="fa fa-commenting-o dollar_icon"></i>
            </div>
          </div>
          <div [hidden]="(invalidComments==true)">
            <span class="input-ErrorField">Invalid Comments</span>
          </div>
        </div>
        <div class="form-group form_main">
          <label class="control-label label_modifi" for="creditmanager">
            <i style="color: #cc0000; ">*</i> Credit Manager Admin
          </label>
          <div class="input-group" style="width:67%">
            <p-select appendTo="body" [options]="financeVPs" [autoWidth]="false" required
              [(ngModel)]="selectedFinanceVP" placeholder="Select Credit Manager Admin" name="financeVP"
              optionLabel="name" [style]="{'width':'92%'}">
              <ng-template pTemplate="selectedItem" let-selectedOption>
                {{ selectedOption?.name }}
              </ng-template>
              <ng-template pTemplate="item" let-option>
                {{ option.name }}
              </ng-template>
            </p-select>
            <i class="fa fa-user popupuser_icon" style="line-height: 32px"></i>
          </div>
          <div [hidden]="(invalidFinanceVP==true)">
            <span class="input-ErrorField">Credit Manager Admin Required</span>
          </div>
        </div>
        <br />
        <p-footer>
          <div class="buttons_main">
            <button type="submit" pButton icon="fa-check" Class="ui-button-success" [disabled]="RefundSubmitBtn"
              label="Submit">
            </button>
            <button type="button" pButton icon="fa-close" Class="ui-button-danger"
              (click)="onRefundSubmitCancel();AddRefundFrm.reset();" label="Cancel">
            </button>
          </div>
        </p-footer>
      </form>
    </p-dialog>

    <div id="CMCommentsPopup">
      <p-dialog header="Credit Manager Comments History" [(visible)]="displayCommentsPopUp" modal="modal"
        [height]="'auto'" [responsive]="true" [resizable]="true" [breakpoint]="650" [width]="650" [blockScroll]="true"
        [draggable]="false" [closable]="false">
        <p-dataTable [rows]="8" [paginator]="true" [pageLinks]="10" [reorderableColumns]="true" columnResizeMode="fit"
          [resizableColumns]="false"
          [tableStyle]="{'table-layout':'fixed','width':'100%','border-collapse': 'collapse','border': '1px solid #c5c5c5'}"
          [responsive]="true" [value]="CommentsDetails">
          <!-- Comments -->
          <p-column field="comments" header="Credit Manager Comments"
            [headerStyle]="{'font-weight': 'bold','width':'200px'}" [sortable]="true">
            <ng-template pTemplate="header">
              <span>Credit Manager
                <br /> Comments</span>
            </ng-template>
            <ng-template>
              <div>{{row.comments}} </div>
            </ng-template>
          </p-column>
          <p-column field="createdBy" header="Updated By" [headerStyle]="{'font-weight': 'bold','width':'142px'}"
            [sortable]="true">
            <ng-template>
              <div>{{row.createdBy}}</div>
            </ng-template>
          </p-column>
          <p-column field="commentsDate" header="Updated Date" [headerStyle]="{'font-weight': 'bold','width':'142px'}"
            [sortable]="true">
            <ng-template>
              <div>{{row.commentsDate}}</div>
            </ng-template>
          </p-column>

        </p-dataTable>
        <!-- <p-column [filter]="enableFilter" field="creditManagerComments" header="CM Admin Comments" [sortable]="true"
                            [headerStyle]="{'font-weight': '900'}">
                            <ng-template let-row="rowData" pTemplate="body">
                                <div>{{row.creditManagerComments}}
                                </div>
                            </ng-template> -->
        <br />
        <div class="form-group form_main">
          <label class="control-label label_modifi labelComment" for="comments">
            <i style="color: #cc0000;">*</i> Credit Manager &nbsp;&nbsp;Comments
          </label>
          <div class="input-group">
            <textarea class="form-control input_modifi" id="Comments" required name="Comments" type="text"
              maxlength="999" [(ngModel)]="newComments"></textarea>
            <div class="input-group-addon add_on">
              <i class="fa fa-commenting-o dollar_icon"></i>
            </div>
          </div>
          <div [hidden]="(invalidCMComments==true)">
            <span class="input-ErrorField">Invalid Credit Manager Comments</span>
          </div>
        </div>